import React, { useEffect, useState } from "react";
import styles from "./layout.module.scss";
import Sidebar from "./Sidebar";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllBrands,
  getAllSellers,
  getLocations,
  getProducts,
  getProfile,
  getRewards,
  getTags,
} from "../../helpers/service";
import {
  setBrands,
  setLocations,
  setProducts,
  setSellers,
  setTags,
} from "../Redux/Reducer/appReducer";
import { configureAxiosInterceptor } from "../../helpers/Api";
import CuteMascotSpinner from "../../global/CuteMascotSpinner";
import { getProfileDetails } from "../Redux/Reducer/authReducer";
import { setRewards } from "../Redux/Reducer/rewardReducer";

const Layout = ({ children }) => {
  const { idToken, role, id } = useSelector((state) => state.authReducer);
  const isAdmin = role === "admin";
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (idToken) {
      configureAxiosInterceptor(idToken);
    }

    return () => {
      console.log("Dashboard unmounting 1");
    };
  }, [idToken]);

  useEffect(() => {
    if (idToken) {
      try {
        fetchUser();
        fetchData();
      } catch (error) {
        console.error(error);
      }
    }

    return () => {
      console.log("Dashboard unmounting 2");
    };
  }, [idToken]);

  useEffect(() => {
    if (idToken && role === "admin") {
      try {
        fetchSellerData();
      } catch (error) {
        console.error(error);
      }
    }
  }, [role, idToken]);

  const fetchUser = async () => {
    if (idToken) {
      const res = await getProfile(idToken);

      dispatch(getProfileDetails(res.data));
    }
  };

  const fetchSellerData = async () => {
    try {
      const sellerData = await getAllSellers();
      handleSellerData(sellerData);
    } catch (error) {
      console.error("Error fetching data:", error.message || error);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const [brandsData, locationData, productData, tagData] =
        await Promise.all([
          getAllBrands(idToken),
          getLocations(idToken),
          getProducts(idToken),
          getTags(idToken),
        ]);

      handleBrandData(brandsData);
      handleLocationData(locationData, brandsData);
      handleProductData(productData, brandsData);
      handleTagData(tagData);

      const rewardsData = await getRewards(idToken);
      handleRewardData(rewardsData);
    } catch (error) {
      console.error("Error fetching data:", error.message || error);
    } finally {
      setLoading(false);
    }
  };

  const handleBrandData = (brandsData) => {
    if (brandsData?.data?.length) {
      const filteredBrands = isAdmin
        ? brandsData.data
        : brandsData.data.filter((brand) => brand.userId === id);
      dispatch(setBrands(filteredBrands));
    }
  };

  const handleLocationData = (locationData, brandsData) => {
    if (locationData?.length && brandsData?.data?.length) {
      const filteredLocations = isAdmin
        ? locationData
        : locationData?.filter((location) =>
            brandsData?.data.some(
              (brand) => brand?.id === location?.brandId && brand?.userId === id
            )
          );
      dispatch(setLocations(filteredLocations));
    }
  };

  const handleProductData = (productData, brandsData) => {
    if (productData?.data?.length && brandsData?.data?.length) {
      const filteredProducts = isAdmin
        ? productData.data
        : productData.data.filter((product) =>
            brandsData.data.some(
              (brand) => brand.id === product.brandID && brand.userId === id
            )
          );
      dispatch(setProducts(filteredProducts));
    }
  };

  const handleTagData = (tagData) => {
    if (tagData?.data?.length) {
      dispatch(setTags(tagData.data));
    } else {
      dispatch(setTags([]));
    }
  };

  const handleSellerData = (sellerData) => {
    if (sellerData?.data?.length) {
      dispatch(setSellers(sellerData.data));
    }
  };

  const handleRewardData = (rewardsData) => {
    if (rewardsData?.data?.rewards) {
      const filteredRewards = isAdmin
        ? rewardsData.data.rewards.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          )
        : rewardsData.data.rewards
            .filter((reward) => reward.sellerId === id)
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      dispatch(setRewards(filteredRewards));
    }
  };

  return (
    <div className={styles["main_container"]}>
      <Sidebar />
      <div className={styles["content_container"]}>
        {loading && <CuteMascotSpinner />}
        {children}
      </div>
    </div>
  );
};

export default Layout;
